import { useStandardLoanStore } from '../../../../../state/standardLoanStore';
import { LoanType } from '../../../../../../../../common/constants/LoanType';
import { ConstructionPanel } from './components/ConstructionPanel';
import { RentalPanel } from './components/RentalPanel';
import { BuildRentPanel } from './components/BuildRentPanel';
import { ModelPanel } from './components/ModelPanel';
import { LandPanel } from './components/LandPanel';
import { FixFlipPanel } from './components/FixFlipPanel';
import { BridgePanel } from './components/BridgePanel/BridgePanel';
import { SubNoteConstructionPanel } from './components/SubNoteConstructionPanel';
import { SubNoteFixFlipPanel } from './components/SubNoteFixFlipPanel';
import { ItemRowSettings } from '../../ItemRow/ItemRow';
import {
    Expander,
    ExpanderBorderRoundingStyle,
    ExpanderBorderStyle,
    ExpanderButtonStyle,
    ExpanderHeaderSpacing,
    ExpanderTheme,
} from '@apply/components';
import '../styles/_sectionContent.scss';

/**
 * The Loan fields of the "Loan" step: a new version of the Loan section of EditStdLoanModal. Shows the panel for the
 * Loan Type chosen in Setup, which has only the fields that apply to that type (the step can't be opened until a type
 * is chosen).
 */
export const LoanInfo = () => {
    const loanTypeId = useStandardLoanStore((state) => state.setup.loanTypeId);

    /** The panel for the chosen loan type; nothing for no type (or a Master Note, which has its own modal). */
    const renderPanel = () => {
        switch (loanTypeId) {
            case LoanType.Construction:
                return <ConstructionPanel />;
            case LoanType.Rental:
                return <RentalPanel />;
            case LoanType.BuildRent:
                return <BuildRentPanel />;
            case LoanType.Model:
                return <ModelPanel />;
            case LoanType.Land:
                return <LandPanel />;
            case LoanType.FixFlip:
                return <FixFlipPanel />;
            case LoanType.Bridge:
                return <BridgePanel />;
            case LoanType.SubNoteConstruction:
                return <SubNoteConstructionPanel />;
            case LoanType.SubNoteFixFlip:
                return <SubNoteFixFlipPanel />;
            default:
                return null;
        }
    };

    return (
        <Expander
            header={<h2>Information</h2>}
            initialExpanded={true}
            theme={ExpanderTheme.White}
            buttonStyle={ExpanderButtonStyle.NoRounding}
            borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
            borderStyle={ExpanderBorderStyle.None}
            headerSpacing={ExpanderHeaderSpacing.None}
            width='auto'
            height='30px'
        >
            <div className='loanSectionContent'>
                {/* Paired fields stack once the step is too narrow for each to keep its 150px label + about 100px of box */}
                <ItemRowSettings.Provider value={{ minItemWidth: 270 }}>{renderPanel()}</ItemRowSettings.Provider>
            </div>
        </Expander>
    );
};
